/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PersonalCertificatesController', PersonalCertificatesController);

    PersonalCertificatesController.$inject = ['PrincipalProfile', 'Auth', 'AlertService', '$translate', 'DateUtils'];

    function PersonalCertificatesController (PrincipalProfile, Auth, AlertService, $translate, DateUtils) {

        var vm = this;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {};
        vm.isafChange = isafChange;

        vm.profile = null;
        vm.save = save;

        PrincipalProfile.identity(true).then(function(profile) {
            vm.profile = profile;
        });

        function save () {
            vm.isSaving = true;
            var profile = angular.copy(vm.profile);
            profile.isafDate = DateUtils.convertLocalDateToServer(profile.isafDate);
            Auth.updateProfile(profile).then(function() {
                vm.error = null;
                vm.isSaving = false;
                PrincipalProfile.identity(true).then(function(profile) {
                    vm.profile = profile;
                });
                AlertService.success($translate.instant('global.messages.update.alert'));
            }).catch(function() {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function isafChange() {
            if(vm.profile.isaf === "") {
                vm.profile.isafDate = "";
            }
        }
    }
})();
